
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-19-resources/covid-19-business-impact",
      function () {
        return require("private-next-pages/covid-19-resources/covid-19-business-impact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-19-resources/covid-19-business-impact"])
      });
    }
  